<template>
	<v-app>
		<v-fade-transition>
			<router-view/>
		</v-fade-transition>

		<v-navigation-drawer v-model="isMainMenuOpen" app fixed right class="uf-navigation-drawer" disable-resize-watcher>
			<v-list class="pt-0" dense>

				<v-img :aspect-ratio="16/9" :src="drawerImage" class="menu-image">
					<div align="center">
						<img class="logo ma-5" src="@/assets/images/logo.svg" alt="E-Connectz" style="width: 60%" width="60%">
					</div>
				</v-img>

				<v-divider></v-divider>

				<v-list-tile @click="gotoMap" ripple>
					<v-list-tile-action>
						<v-icon>map</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>Mijn E-finders</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile @click="gotoAccount" ripple>
					<v-list-tile-action>
						<v-icon>account_circle</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>Account</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile @click="gotoHelp" ripple>
					<v-list-tile-action>
						<v-icon>help</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>Help & Support</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-divider></v-divider>

				<v-list-tile @click="gotoAdvanced" ripple v-if="device">
					<v-list-tile-action>
						<v-icon>bluetooth</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>Geavanceerd</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-divider v-if="device"></v-divider>

				<v-list-tile @click="logout" ripple>
					<v-list-tile-action>
						<v-icon>people</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>Logout</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

			</v-list>
			<v-container class="text-xs-right">
				<p>v{{ version }}</p>
			</v-container>
		</v-navigation-drawer>

		<v-dialog v-model="offline" persistent max-width="290">
			<v-card>
				<v-card-title class="headline">Offline</v-card-title>
				<v-card-text>
					<div v-if="!connecting">Er is geen internet verbinding beschikbaar.</div>
					<v-progress-linear v-else indeterminate class="mb-0"></v-progress-linear>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click.native="connect()" color="darken-1" flat>Verbinden</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-app>
</template>

<script>
	import Offline from 'v-offline';
	import DrawerImage from '@/assets/images/bg-welcome.jpg';
	import {mapGetters} from "vuex";

	export default {

		components: {
			Offline,
		},
		timers: {
			increaseMessageIndex: { time: 2500, autostart: true, repeat: true },
			loadUnreadNotificationCount: { time: 60000, autostart: true, repeat: true }
		},
		data() {
			return {
				version: process.env.VUE_APP_VERSION,
                isRunningInBrowser: process.env.CORDOVA_PLATFORM === 'browser',
				connecting: false,
				connectingTimeout: null,
				drawerImage: DrawerImage,
			};
		},
		computed: {
			...mapGetters(['isLoggedIn']),
			online() {
				return this.$store.state.online;
			},
			offline() {
				return !this.$store.state.online;
			},
			isMainMenuOpen: {
				set(value) {
					if (value) {
                      this.$store.dispatch('openMainMenu');
                    }else{
					  this.$store.dispatch('closeMainMenu');
                    }
				},
				get() {
					return this.$store.state.isMainMenuOpen;
				},
			},
			device() {
				return this.$store.getters.device || null;
			},

		},
		methods: {
			gotoMap() {
				this.$router.push({name: 'devices.index'});
				this.$store.dispatch('closeMainMenu');
			},
			gotoAccount() {
				this.$router.push('/account');
				this.$store.dispatch('closeMainMenu');
			},
			gotoHelp() {
				this.$router.push('/help');
				this.$store.dispatch('closeMainMenu');
			},
            gotoAdvanced() {
				this.$router.push({name: 'devices.advanced', props: { id: this.device.id }});
				this.$store.dispatch('closeMainMenu');
			},
			logout() {
				this.$store.dispatch('logout');
				this.$store.dispatch('closeMainMenu');
				this.$router.push('/');
			},
			increaseMessageIndex() {
				this.$store.dispatch('increaseMessageIndex');
			},
			connect() {
				if (this.connectingTimeout) clearTimeout(this.connectingTimeout);
				this.connecting = true;
				this.connectingTimeout = setTimeout(() => {
					this.connecting = false;
				}, 3000);
			},
			loadUnreadNotificationCount() {
				if (!this.isLoggedIn) return;
				this.$store.dispatch('loadUnreadNotificationCount');
			},
		},
		created() {
			navigator.onLine ? this.$store.dispatch('appOnline') : this.$store.dispatch('appOffline');
			window.addEventListener('online', () => this.$store.dispatch('appOnline'));
			window.addEventListener('offline', () => this.$store.dispatch('appOffline'));
		},
	};
</script>

<style lang="stylus">
    html, body {
        height: 100%;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

	.application {
		position: fixed;
		overflow: auto;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		min-height: 100%;
	}

	.application--wrap {
		min-height: 100%;
	}


	.menu-image {
		background-color: #17263C
	}

	.menu-image > .v-image__image{
		opacity: .25
	}
</style>
